import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "nearbyDevice"
const NearbyDeviceIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m17.992 7.17 3.428 3.41a2 2 0 0 1 0 2.83l-5.667 5.66-2.339 2.34a1.998 1.998 0 0 1-2.828 0l-2.35-2.35-5.646-5.65a2 2 0 0 1 0-2.83l3.408-3.42 4.588-4.58a2 2 0 0 1 2.828 0l4.578 4.59ZM11.995 19.2l5.997-6 1.2-1.21-1.2-1.2-5.997-6-5.997 6-1.2 1.21 1.2 1.2 5.997 6Zm-4.418-7.21 4.428-4.41 4.418 4.41-4.418 4.42-4.428-4.42Z"
      />
    </svg>
  )
}
export default NearbyDeviceIcon
